import axios from "axios";

export interface ClanTaskReward {
  oil?: number,
  coal?: number,
}

export interface ClanTask {
  taskId: number,
  clanId: number,
  name: string,
  order: number,
  claimedAt?: string,
  finishedTill?: string,
  progress: number,
  isFinished: boolean,
  isClaimed: boolean,
  reward?: ClanTaskReward,
}

export type GET_CLAN_TASKS_TYPE = 'GET_CLAN_TASKS'
export const GET_CLAN_TASKS: GET_CLAN_TASKS_TYPE = 'GET_CLAN_TASKS'

export type GET_CLAN_TASKS_RESPONSE_TYPE = 'GET_CLAN_TASKS_RESPONSE'
export const GET_CLAN_TASKS_RESPONSE: GET_CLAN_TASKS_RESPONSE_TYPE = 'GET_CLAN_TASKS_RESPONSE'

export const getClanTasks = () => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: GET_CLAN_TASKS,
    })

    const state = getState();

    axios.get(state.urls.darwinGetTasks).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: GET_CLAN_TASKS_RESPONSE,
                payload: response.data.items,
            })
        }
    })
}

export type CLAIM_CLAN_TASK_TYPE = 'CLAIM_CLAN_TASK'
export const CLAIM_CLAN_TASK: CLAIM_CLAN_TASK_TYPE = 'CLAIM_CLAN_TASK'

export type CLAIM_CLAN_TASK_RESPONSE_TYPE = 'CLAIM_CLAN_TASK_RESPONSE'
export const CLAIM_CLAN_TASK_RESPONSE: CLAIM_CLAN_TASK_RESPONSE_TYPE = 'CLAIM_CLAN_TASK_RESPONSE'

export const claimClanTask = (taskId: number) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: CLAIM_CLAN_TASK,
    })

    const state = getState();

    axios.patch(state.urls.darwinClaimTask.replace('{task_id}', taskId)).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: CLAIM_CLAN_TASK_RESPONSE,
                payload: response.data,
            })
        }
    }).catch(() => {
      dispatch(getClanTasks())
    })
}

export type CLAIM_CLAN_TASKS_TYPE = 'CLAIM_CLAN_TASKS'
export const CLAIM_CLAN_TASKS: CLAIM_CLAN_TASKS_TYPE = 'CLAIM_CLAN_TASKS'

export type CLAIM_CLAN_TASKS_RESPONSE_TYPE = 'CLAIM_CLAN_TASKS_RESPONSE'
export const CLAIM_CLAN_TASKS_RESPONSE: CLAIM_CLAN_TASKS_RESPONSE_TYPE = 'CLAIM_CLAN_TASKS_RESPONSE'

export const claimClanTasks = () => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: CLAIM_CLAN_TASKS,
    })

    const state = getState();

    axios.patch(state.urls.darwinClaimAllTasks).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: CLAIM_CLAN_TASKS_RESPONSE,
                payload: response.data,
            })
        }
    }).catch(() => {
      dispatch(getClanTasks())
    })
}
